import { ClipboardCheck, ArrowUpRight, Lock, Copy, Check } from "lucide-react";
import { useState } from "react";

export const UnderReviewStep = ({ t, code, submittedAtStr, onContinue }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (e) {
      if (process.env.NODE_ENV === "development") console.error("Copy to clipboard failed:", e);
    }
  };

  return (
    <div data-testid="register-under-review" className="p-10 flex flex-col items-center text-center gap-4">
      <ClipboardCheck className="w-12 h-12 text-brand-blue" strokeWidth={1.5} />
      <p className="font-heading text-lg font-bold">{t.modal.underReviewTitle}</p>
      <p data-testid="register-under-review-submitted-date" className="text-neutral-500 text-xs uppercase tracking-wide font-semibold">
        {t.modal.underReviewSubmittedOn} {submittedAtStr}
      </p>
      <p data-testid="register-under-review-message" className="text-neutral-400 text-sm leading-relaxed">
        {t.modal.underReviewMessage}
      </p>

      <div className="w-full rounded-xl border border-brand-blue/30 bg-brand-blue/[0.06] p-4 flex flex-col gap-2">
        <p className="text-neutral-400 text-xs">{t.modal.yourCodeLabel}</p>
        <div className="flex items-center justify-between gap-3">
          <span data-testid="register-under-review-code" className="font-mono text-white text-base font-bold tracking-wide">{code}</span>
          <button
            type="button"
            data-testid="register-under-review-copy-code-button"
            onClick={handleCopy}
            className="inline-flex items-center gap-1.5 text-xs font-semibold text-brand-blue hover:text-white transition-colors duration-200"
          >
            {copied ? <Check className="w-3.5 h-3.5" /> : <Copy className="w-3.5 h-3.5" />}
            {copied ? t.modal.copiedLabel : t.modal.copyButton}
          </button>
        </div>
        <p className="text-neutral-500 text-[11px] leading-relaxed text-left">{t.modal.yourCodeHint}</p>
      </div>

      <div className="flex items-start gap-2.5 rounded-xl border border-brand-red/30 bg-brand-red/[0.06] p-4 text-left">
        <Lock className="w-4 h-4 text-brand-red shrink-0 mt-0.5" />
        <p data-testid="register-under-review-locked-note" className="text-neutral-300 text-xs leading-relaxed">{t.modal.underReviewLockedNote}</p>
      </div>
      <button
        type="button"
        data-testid="register-under-review-continue-button"
        onClick={onContinue}
        className="mt-2 w-full bg-brand-red text-white font-bold text-sm py-3 rounded-full flex items-center justify-center gap-2 hover:-translate-y-0.5 hover:bg-brand-redDark shadow-[0_8px_24px_-6px_rgba(255,36,54,0.5)] transition-all duration-300"
      >
        {t.modal.underReviewContinueButton}
        <ArrowUpRight className="w-4 h-4" />
      </button>
    </div>
  );
};
